import {
    Button, Dialog, DialogActions, DialogContent, DialogTitle, LinearProgress
} from '@mui/material';
import { withStyles } from '@mui/styles';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { indigo } from '@mui/material/colors';
import { COLORS } from '../../utils';

const styles = theme => ({
    actions: {
        justifyContent: 'space-between'
    },
    action: {
        justifyContent: 'center',
        padding: '15px'
    },
    actionButtons: {
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2)
    },
    hidden: {
        opacity: 0
    },
    backgroundColor: {
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: indigo[50]
    },
    actionButtonDownload: {
        display: 'block',
        marginLeft: theme.spacing(2),
    },
    wrapperProgress: {
        backgroundColor: '#80C6B5',
        height: '4px'
    }
});

const Actions = ({ actions, classes, onClose, disableButtonSave, t }) =>

    actions.map((action, i) => {
        const { translateId, ...rest } = action;

        rest.className = classNames(rest.className, classes.actionButtons);

        if (action.type === 'submit') {
            rest.color = 'secondary';
        }

        if (action.type === 'cancel') {
            rest.onClick = onClose;
            rest.type = 'button';
        }

        return (
            <Button
                {...rest}
                key={i}
                variant={action.variant}
                disabled={action.type === 'submit' ? disableButtonSave : false}
            >
                {t(translateId)}
            </Button>
        );
    });
Actions.propTypes = {
    actions: PropTypes.array.isRequired,
    classes: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired,
    disableButtonSave: PropTypes.bool,
};

const CommonDialog = ({
    children,
    className,
    open,
    title,
    maxWidth = 'xs',
    actions,
    classes,
    onClose,
    hidden = false,
    backgroundColor,
    disableButtonSave,
    isLoading,
    t,
    ...rest
}) => {
    const _classes = classNames(className, {
        [classes.hidden]: hidden,
    });

    const _classesDialogBackground = classNames(className, {
        [classes.backgroundColor]: backgroundColor,
    });

    return (
        <Dialog
            className={_classes}
            onClose={onClose}
            maxWidth={maxWidth}
            open={open}
            arearia-labelledby="form-dialog-title"
            fullWidth
            {...rest}
        >
            <div className={classes.wrapperProgress}>
                {isLoading && <LinearProgress />}
            </div>
            <DialogTitle
                className={_classesDialogBackground}
                id="form-dialog-title"
                style={{ backgroundColor: COLORS.secondary.main, marginBottom: '15px' }}
                color="primary"
            >
                {title}
            </DialogTitle>
            <DialogContent
                className={_classesDialogBackground}
                style={{ paddingTop: 0 }} //  this is needed for the accordion (temporarily)
            >
                {children}
            </DialogContent>
            <DialogActions
                className={
                    classNames(
                        actions.length === 1 ? classes.action : classes.actions,
                        backgroundColor && classes.backgroundColor
                    )
                }
            >
                <Actions
                    actions={actions}
                    classes={classes}
                    onClose={onClose}
                    disableButtonSave={disableButtonSave}
                    t={t}
                />
            </DialogActions>
        </Dialog>
    );
};

CommonDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    title: PropTypes.oneOfType([
        PropTypes.string.isRequired,
        PropTypes.object.isRequired
    ]),
    maxWidth: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
    actions: PropTypes.array.isRequired,
    classes: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired,
    hidden: PropTypes.bool,
    className: PropTypes.string,
    children: PropTypes.node,
    disableButtonSave: PropTypes.bool
};

export default withStyles(styles)(CommonDialog);
